import { ApiProperty } from "@nestjs/swagger";

 export class RolesIdReqDto{
    @ApiProperty()
    rolesId:number;
 }